// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-C1":"C1_outdoor-recreation-C1__LIVZ_"};